import './stack.css';
import Drupal from '../Assets/drupal.jpg';
import R from '../Assets/react1.png';
import F from '../Assets/flutter1.png';
import W from '../Assets/wordpress1.png';
import RN from '../Assets/ReactNative.png';
import N from '../Assets/nodejs.jpg';
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

export default function Stack() {
  return (
    <Box sx={{ flexGrow: 1, }}>
      <Container maxWidth="lg" style={{ marginTop: "5%", }} >
      <Typography variant="h1" gutterBottom align='center' fontSize={'120%'} className="about-us-text" style={{ marginTop: "2%", }} 
        fontStyle="">
          ჩვენი კოლეჯი სასწავლებლად უნდა აირჩიო იმიტომ რომ:
        </Typography>
        <Typography variant="subtitle2" gutterBottom align='justify' fontSize={'120%'} className="about-us-text" style={{ marginTop: "5%", }} 
        fontStyle="">
          <li>     დაიწყო აქტიური საგანმანათლებლო და შემოქმედებითი ცხოვრება</li>

<li>     გახდე დამოუკიდებელი და მოაზროვნე მოქალაქე</li>

<li>     პროფესიონალი გუნდის მეშვეობით ფოკუსირება მოახდინო პიროვნული და პროფესიული უნარების განვითარებაზე</li>

<li>     განავითარო უნარები სასწავლო პროცესში ინოვაციური მიდგომების, პრაქტიკისა და  სტაჟირების საფუძველზე</li>

<li>     შეიგრძნო არსებული სასურველი გარემო და ატმოსფერო</li>

<li>     გახდე კოლეჯის ცეკვის ჯგუფის ,,ჯი ფოლკის’’ მოცეკვავე-მსახიობი</li>

<li>     გახდე თანამედროვე ქორეოგრაფიის თეატრის ,,იმპულსის’’ მოცეკვავე-მსახიობი</li>

<li>     შეიძინო ახალი მეგობრები და გახდე ზაქარიაძელების დიდი ოჯახის წევრი</li>

<li>     კოლეჯის ხელშეწყობით დასაქმდე</li>

<li> გახდე პროფესიული განვითარების, თვითრეალიზაციისა და ახალი გამოწვევების მონაწილე</li>

<li> იმოგზაურო და მიიღო საერთაშორისო გამოცდილება</li>

<li> უკეთესად გაეცნო საკუთარ თავს, გახდე სოციალური ცხოვრების ნაწილი და გაუმკლავდე რისკებს</li>

<li> გაუფრთხილდე კულტურულ მემკვიდრეობას და შეინარჩუნო ეროვნული ღირებულებები</li>

<li> იპოვო თანამდგომი და თანამოაზრე</li>

<li> შენთვის შეუძლებელი ჩვენთან შესაძლებელია</li>
        </Typography>
        <Typography variant="h5" gutterBottom align='center'>
          <h1 className="about-us-title">ჩვენ შესახებ</h1>
        </Typography>
        <Typography variant="subtitle1" gutterBottom align='justify' fontSize={'120%'} className="about-us-text" style={{ marginTop: "2%", }} 
        fontFamily={"Lucida Console, Courier New, monospace"}>
ქალაქ თბილისის მუნიციპალიტეტის მერიის სერგო ზაქარიაძის სახელობის ტრადიციული და თანამედროვე ხელოვნების კოლეჯი შეიქმნა 1937 წელს.  

კოლეჯმა აღზარდა ათასობით წარმატებული და პროფესიონალი სპეციალისტი. წლების მანძილზე კოლეჯში მოღვაწეოდნენ ქართული კულტურის სფეროს სასიქადულო წარმომადგენლები - რეჟისორები, კომპოზიტორები, ქორეოგრაფები. სასწავლებელს მუდამ ჰყავდა საუკეთესო პედაგოგ-აღმზრდელები: დ. ჯავრიშვილი, ვ. ჯინორია, ა. ჩიხლაძე, გ. ლაცაბიძე, რ.კაცაძე, ლ. გვარამაძე, ა.თათარაძე, ჯ. სამხარაული, ჯ. ბაგრატიონი, მ. მეძმარიაშვილი, ლ. შატბერაშვილი, კ. გურგენიძე, გ. საღარაძე. ო. კელაპტრიშვილი, მ. მესარკიშვილი, კ. მანჯგალაძე, ა. შალიკაშვილი, რომელიც ასევე 1960 წლის სასწავლებლის კურსდამთავრებული იყო და სხვები, რომლებმაც აღზარდეს სახელოვანი მაღალკვალიფიციური სპეციალისტები. 

2007 წლის საქართველოში საგანმანათლებლო რეფორმის შემდეგ, კოლეჯი ქალაქ თბილისის მერიის დაქვემდებარებული დაწესებულებაა, რომელიც აწარმოებს საშუალო სპეციალიზირებულ მოკლევადიან და გრძელვადიან საგანმანათლებლო პროგრამებს, შემდეგ მიმართულებებზე: ქორეოგრაფიული, თეატრალური - სარეჟისორო, ქართული ტრადიციული სიმღერა და გალობა, თოჯინების კეთება, სახვითი ხელოვნების, პოლიგრაფიულ სარეკლამო საქმიანობა და გრაფიკული დიზაინი, ორატორული ხელოვნების სასწავლო კურსი. 

კოლეჯი აქტიურად თანამშრომლობს ლოძის (პოლონეთი) ახალგაზრდულ სასახლესთან, სლავუტიჩისა და კიევის (უკრაინა) შემოქმედებით კოლექტივებთან, მინსკის (ბელარუსია), რიგის (ლატვია) ფესტივალებთან.

კოლეჯს ჰყავს ცეკვის ჯგუფი ,,ჯი ფოლკი’’, რომელიც აქტიურად იღებს მონაწილეობას ადგილობრივ და საერთაშორისო ღონისძიებებში. 

კოლეჯში არსებობს ექსპერიმენტული თეატრი, რომელიც უანგაროთ ემსახურება ყველა ნიჭიერ ხელოვანს. ეს არის სივრცე, სადაც შეგიძლია აქციო წარმოსახვა რეალობად. ექსპერიმენტულ თეატრს ხშირად სტუმრობს გამოჩენილი ხელოვანები, იმართება სხვადასხვა სახის ღონისძიებები.
      
        </Typography>
      </Container>
    </Box>
  );
}